import { blue, green, red, yellow } from "@mui/material/colors";

let AsaasPaymentStatusUtils: {
  status: string;
  text: string;
  backgroundColor: string;
  textColor: string;
}[] = [];

AsaasPaymentStatusUtils["PENDING"] = {
  status: "PENDING",
  text: "Aguardando pagamento",
  backgroundColor: yellow[100],
  textColor: yellow[800],
};

AsaasPaymentStatusUtils["RECEIVED"] = {
  status: "RECEIVED",
  text: "Pagamento recebido",
  backgroundColor: green[100],
  textColor: green[800],
};

AsaasPaymentStatusUtils["PAID"] = {
  status: "PAID",
  text: "Pagamento recebido",
  backgroundColor: green[100],
  textColor: green[800],
};

AsaasPaymentStatusUtils["CONFIRMED"] = {
  status: "CONFIRMED",
  text: "Pagamento confirmado",
  backgroundColor: green[100],
  textColor: green[800],
};

AsaasPaymentStatusUtils["OVERDUE"] = {
  status: "OVERDUE",
  text: "Vencido",
  backgroundColor: red[100],
  textColor: red[800],
};

AsaasPaymentStatusUtils["CANCELLED"] = {
  status: "CANCELLED",
  text: "Vencido",
  backgroundColor: red[100],
  textColor: red[800],
};

AsaasPaymentStatusUtils["REFUNDED"] = {
  status: "REFUNDED",
  text: "Estornado",
  backgroundColor: blue[100],
  textColor: blue[800],
};

AsaasPaymentStatusUtils["RECEIVED_IN_CASH"] = {
  status: "RECEIVED_IN_CASH",
  text: "Recebido em dinheiro",
  backgroundColor: green[100],
  textColor: green[800],
};

AsaasPaymentStatusUtils["REFUNDED_REQUESTED"] = {
  status: "REFUNDED_REQUESTED",
  text: "Estorno solicitado",
  backgroundColor: yellow[100],
  textColor: yellow[800],
};

AsaasPaymentStatusUtils["CHARGEBACK_REQUESTED"] = {
  status: "CHARGEBACK_REQUESTED",
  text: "Recebido chargeback",
  backgroundColor: yellow[100],
  textColor: yellow[800],
};

AsaasPaymentStatusUtils["CHARGEBACK_DISPUTE"] = {
  status: "CHARGEBACK_DISPUTE",
  text: "Em disputa de chargeback",
  backgroundColor: yellow[100],
  textColor: yellow[800],
};

AsaasPaymentStatusUtils["AWAITING_CHARGEBACK_REVERSAL"] = {
  status: "AWAITING_CHARGEBACK_REVERSAL",
  text: "Aguardando repasse do chargeback",
  backgroundColor: red[100],
  textColor: red[800],
};

AsaasPaymentStatusUtils["DUNNING_REQUESTED"] = {
  status: "DUNNING_REQUESTED",
  text: "Negativação solicitada",
  backgroundColor: red[100],
  textColor: red[800],
};

AsaasPaymentStatusUtils["DUNNING_RECEIVED"] = {
  status: "DUNNING_RECEIVED",
  text: "Recuperada",
  backgroundColor: red[100],
  textColor: red[800],
};

AsaasPaymentStatusUtils["AWAITING_RISK_ANALYSIS"] = {
  status: "AWAITING_RISK_ANALYSIS",
  text: "Pagamento em análise",
  backgroundColor: yellow[100],
  textColor: yellow[800],
};

export default AsaasPaymentStatusUtils;
